import React from 'react';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';

import VerticalDate from '@components/Dates/VerticalDate';

import { isMainStatementLine } from '../helpers';

const Wrapper = styled.div`
    min-width: 4.5rem;
    min-height: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.commission-row,
    &.advance-row {
        min-height: 2.7rem;
        display: block;
    }
`;

const hasValidDate = (date) => {
    return Boolean(date) && getMoment(date).year() > 1900;
};

const StatementDateCell = ({ row, variant = 'billing-search' }) => {
    if (variant === 'project-grouped' && !isMainStatementLine(row)) {
        return <Wrapper className="transaction-date commission-row">&nbsp;</Wrapper>;
    }

    let date = null;
    let cancelled = false;

    if (variant === 'project-grouped') {
        if (hasValidDate(row.WorkDate)) {
            date = row.WorkDate;
            cancelled = row.WorkDateCancelled;
        } else if (!row.WorkDate && hasValidDate(row.RefDate)) {
            date = row.RefDate;
            cancelled = row.WorkDateCancelled;
        }
    } else if (hasValidDate(row.RefDate)) {
        date = row.RefDate;
    }

    if (!date) {
        return (
            <Wrapper className="transaction-date">
                <small className="upper super-muted">no date</small>
            </Wrapper>
        );
    }

    return (
        <Wrapper className="transaction-date">
            <VerticalDate size="small" date={date} verticalPadding="0" cancelled={cancelled} />
        </Wrapper>
    );
};

export default StatementDateCell;
